import React, { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import swal from "sweetalert";
import { useSearchParams, NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function Edit_subAdmin() {
  const { userId, username, jwt_token } = useSelector((state) => state.Auth);
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();
  const [editId, setId] = useState(searchParams.get("id"));
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [select, setSelect] = useState("");
  const [password, setPassword] = useState("");
  const [ConfirmPassword, setConfPassword] = useState("");
  const [loginId, setLoginId] = useState("");
  const [phone, setPhone] = useState("");
  const [position, setPosition] = useState("");
  const [positionfilter, setpositionfilter] = useState("0");
  const [StatusFilter, setStatusFilter] = useState("2");

  const referral_API = async () => {
    try {
      let responceRight = await API?.post(
        "/editAddSubAdmin",
        {
          type: 2,
          name: name,
          email: email,
          mobile: phone,
          position: "SubAdmin",
          role: "SubAdmin",
          userid: loginId,
          password: password,
          ConfirmPassword: ConfirmPassword,
          username: userId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log('My_Team', responceRight?.data?.data)
      if (responceRight?.data?.data == "sub admin updated successfully") {
        toast.success("SubAdmin Updated Successfully");
        setTimeout(() => {
          navigate("/Manage_subadmin");
        }, 1000);
      } else {
        toast.error(responceRight?.data?.data);
      }
    } catch (e) {
      if (e.response.status === 401) {
      } else {
        console.log("Error While calling Myteam API", e);
      }
    }
  };

  const Edit_data = async () => {
    try {
      let responceRight = await API?.post(
        `/editSubAdminData`,
        {
          username: userId,
          id: editId,
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      //console.log('My_Team=>', responceRight?.data?.data?.records[0])
      responceRight = responceRight?.data?.data?.records[0];
      setName(responceRight.name);
      setEmail(responceRight.email);
      //setSelect(responceRight.role)
      setLoginId(responceRight.user_id);
      //setPosition(responceRight.position)
      setPhone(responceRight.phone);
    } catch (e) {
      if (e.response.status === 401) {
      } else {
        console.log("Error While calling Myteam API", e);
      }
    }
  };

  useEffect(() => {
    Edit_data();
  }, []);

  return (
    <div>
      <Navbar />
      <div class="content-page content_page_hit">
        <div class="content">
          <div class="panel panel-primary">
            <div class="panel-heading">
              <h4 class="panel-title">
                <a href="/Manage_subadmin">View All Sub Admin List</a>
              </h4>
            </div>
            <div class="panel-body table-rep-plugin">
              <div class="row">
                <div class="box col-md-12">
                  <div class="box-inner">
                    <div class="box-content">
                      <div id="multi">
                        <div id="view1">
                          <form>
                            {" "}
                            <div class="form-horizontal">
                              <div class="form-group">
                                <label class="col-sm-2 control-label text-left">
                                  Login ID
                                </label>
                                <div class="col-sm-5">
                                  <input
                                    class="form-control"
                                    id="user_id"
                                    name="user_id"
                                    // onChange={(e)=>setLoginId(e.target.value)}
                                    type="text"
                                    value={loginId}
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div class="form-group">
                                <label class="col-sm-2 control-label text-left">
                                  Name
                                </label>
                                <div class="col-sm-5">
                                  <input
                                    class="form-control"
                                    id="name"
                                    name="name"
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                  />
                                </div>
                              </div>
                              <div class="form-group">
                                <label class="col-sm-2 control-label text-left">
                                  Email ID
                                </label>
                                <div class="col-sm-5">
                                  <input
                                    class="form-control"
                                    id="email"
                                    name="email"
                                    onChange={(e) => setEmail(e.target.value)}
                                    type="text"
                                    value={email}
                                  />
                                </div>
                              </div>
                              <div class="form-group">
                                <label class="col-sm-2 control-label text-left">
                                  Mobile No.
                                </label>
                                <div class="col-sm-5">
                                  <input
                                    class="form-control"
                                    id="phone"
                                    name="phone"
                                    type="num"
                                    value={phone}
                                    onChange={(e) => setPhone(e.target.value)}
                                  />
                                </div>
                              </div>
                              {/* <div class="form-group">
                                                                <label class="col-sm-2 control-label text-left">Position</label>
                                                                <div class="col-sm-5">
                                                                    <input
                                                                        class="form-control"
                                                                        id="position"
                                                                        name="position"
                                                                        type="text"
                                                                        value={position}
                                                                    />
                                                                    <span
                                                                        class="field-validation-valid text-danger"
                                                                        data-valmsg-for="position"
                                                                        data-valmsg-replace="true"
                                                                    ></span>
                                                                </div>
                                                            </div>
                                                            <div class="form-group">
                                                                <label class="col-sm-2 control-label text-left">Role</label>
                                                                <div class="col-sm-5">
                                                                    <select class="form-control" onChange={(e) => setSelect(e.target.value)} id="role" name="role">
                                                                        <option value="">--Select Role--</option>
                                                                        <option value="Admin">Admin</option>
                                                                        <option selected="selected" value="Subadmin">
                                                                            Subadmin
                                                                        </option>
                                                                    </select>
                                                                    <span
                                                                        class="field-validation-valid text-danger"
                                                                        data-valmsg-for="role"
                                                                        data-valmsg-replace="true"
                                                                    ></span>
                                                                </div>
                                                            </div> */}

                              <div class="form-group">
                                <label class="col-sm-2 control-label text-left">
                                  Password
                                </label>
                                <div class="col-sm-5">
                                  <input
                                    class="form-control"
                                    id="pswd"
                                    onChange={(e) =>
                                      setPassword(e.target.value)
                                    }
                                    name="pswd"
                                    type="password"
                                    placeholder="Enter Password"
                                  />
                                </div>
                              </div>
                              <div class="form-group">
                                <label class="col-sm-2 control-label text-left">
                                  Confirm Password
                                </label>
                                <div class="col-sm-5">
                                  <input
                                    class="form-control"
                                    id="ConfirmPassword"
                                    onChange={(e) =>
                                      setConfPassword(e.target.value)
                                    }
                                    name="ConfirmPassword"
                                    type="password"
                                    placeholder="Enter Confirm Password"
                                  />
                                </div>
                              </div>
                              <div class="form-actions text-right">
                                <input
                                  type="button"
                                  value="Update"
                                  onClick={() => referral_API()}
                                  class="btn btn-primary"
                                />
                              </div>
                            </div>
                          </form>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Edit_subAdmin;
